export enum ApiTag {
  UsersList = "UsersList",
  User = "User",
  DepositTransactionsList = "DepositTransactionList",
  WithdrawalTransactionsList = "WithdrawalTransactionList",
}
